import { ISchemaError } from "../interfaces/ISchemaError/ISchemaError";
import { z } from "zod";

export const createdAtSchema = z.preprocess((arg) => (typeof arg === "string" ? new Date(arg) : arg), z.date({ invalid_type_error: ISchemaError.CREATED_AT_INVALID_TYPE }));
